import React from 'react';
import Chip from 'Views/Components/Chip/Chip';

const CompleteCreditChip = () => {
	return (
		<Chip
			className="complete-credit-chip green"
			chipLabel={window.lexicon.completedCredit}
		/>
	);
};

export default CompleteCreditChip;
